import React, { useState, useEffect } from "react";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { Box } from "@mui/material";
import letterLogoPreview from "../assets/images/Download/letterlogs.png";
import mediaKitPreview from "../assets/images/Download/media.png";
import Archive from "../assets/images/Download/Archive.png";
import  lettersPreview from "../assets/images/Download/Letter.png";


const MEDIA_KIT_FOLDER_PREVIEWS = {
  "Archive": Archive,
  "Media Kit": mediaKitPreview,
  "Letters": lettersPreview,
  "Logos, QR & Fonts": letterLogoPreview, // or use another image if you want
};

const API_KEY = "AIzaSyBzcAiQlryjAWkEfRxxb_HFy5aKnJR7x2A"; // 🔒 Put your API key here

const TABS = [
  {
    label: "Archive",
    folderId: "1RnOXMSmMoJZFy62IlbmCabTA91hdQwMj",
  },
  {
    label: "Letter Logos",
    folderId: "1ftXYeuda_vy4I0CGEuecCTrCKkJyzxVw",
  },
  {
    label: "Media Kit",
    folderId: "148_dJevD6PGK6vJ-bbSPU0yWXiwhNNmg",
  },
];

export default function DownloadPage() {
  const [activeTab, setActiveTab] = useState(0);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [folderLoading, setFolderLoading] = useState(false);

  // 🔄 Fetch files when tab changes
  useEffect(() => {
    fetchFiles(TABS[activeTab].folderId);
  }, [activeTab]);

  const fetchFiles = async (folderId) => {
    try {
      setLoading(true);

      const res = await fetch(
        `https://www.googleapis.com/drive/v3/files?q='${folderId}'+in+parents&key=${API_KEY}&fields=files(id,name,mimeType)`
      );

      const data = await res.json();
      setFiles(data.files || []);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  // 📦 Download entire folder as ZIP
  const downloadFolder = async (folderId, folderName) => {
    try {
      setFolderLoading(true);

      const listRes = await fetch(
        `https://www.googleapis.com/drive/v3/files?q='${folderId}'+in+parents&key=${API_KEY}&fields=files(id,name,mimeType)`
      );

      const data = await listRes.json();
      const zip = new JSZip();

      for (const file of data.files) {
        const fileRes = await fetch(
          `https://www.googleapis.com/drive/v3/files/${file.id}?alt=media&key=${API_KEY}`
        );

        const blob = await fileRes.blob();
        zip.file(file.name, blob);
      }

      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, `${folderName}.zip`);
    } catch (error) {
      console.error("Download error:", error);
    } finally {
      setFolderLoading(false);
    }
  };
  

  return (
    
    <div style={{ padding: "", fontFamily: "var(---default-font)" }}>
    {/* 🔵 Banner Image */}
<div
  style={{
    width: "100%",
    height: "100%",
    objectFit:"cover"
  }}
>
  <Box
  className="downloadBg commonBannerBg"
 sx={{
          width: "100%",
          height: { xs: "250px", md: "400px" },
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
 }}
/>
</div>
      <h1 style={{ textAlign: "center" }}>Download Center</h1>

      {/* Tabs */}
      <div
        style={{
          display: "flex",
          gap: "20px",
          justifyContent: "left",
          alignItems:"left",
          marginLeft:"6.5%",
          fontFamily:"var(--default-font)",
          marginBottom: "30px",
          height: "100%"
        }}
      >
        {TABS.map((tab, index) => (
          <button
  key={index}
  onClick={() => setActiveTab(index)}
  style={{
    padding: "10px 20px",
    fontSize:"100%",    
    cursor: "pointer",
    fontFamily:"var(--default-font) !important",
    background:
      activeTab === index
        ? "linear-gradient(90deg, #4b77b1,#005498)"
        : "#e0e0e0",
    color: activeTab === index ? "#fff" : "#000",
    border: "none",
    borderRadius: "6px",
  }}
>
        {tab.label}
          </button>
        ))}
      </div>

      {/* Loading */}
      {loading && <p style={{ textAlign: "center" }}>Loading files...</p>}

      {/* Files Grid */}
      <div
        style={{
          display: "grid",
    marginBottom: "100px",
    gridTemplateColumns: "repeat(auto-fit, 250px)", // fixed card width
    justifyContent: "center",  // 👈 THIS CENTERS THE WHOLE ROW
    columnGap: "20px",
    rowGap: "40px",
 }}
      >
        {files.map((file) => (
          <div
            key={file.id}
            style={{
              border: "1px solid #ddd",
              padding: "10px",
              borderRadius: "10px",
              textAlign: "center",
              height: "100%",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",     

            }}
          >
    <img
 src={
  TABS[activeTab].label === "Letter Logos"
    ? lettersPreview
    : file.mimeType === "application/vnd.google-apps.folder"
    ? MEDIA_KIT_FOLDER_PREVIEWS[file.name] || mediaKitPreview
    : `https://drive.google.com/thumbnail?id=${file.id}&sz=w1500`
}
  alt={file.name}
  style={{
    width: "100%",
    height: "300px",
    objectFit: "cover",
    borderRadius: "12px",
    marginBottom: "10px",
  }}
/>

            <p style={{ fontSize: "14px",fontWeight:"bold", wordBreak: "break-word", minHeight: "40px" }}>
              {file.name}
            </p>

            <a
              href={`https://drive.google.com/uc?export=download&id=${file.id}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                padding: "6px",
                fontFamily:"var(---default-font) !important",
               background:"linear-gradient(90deg, #4b77b1,#005498)",
               color:"white",
               width:"12rem",
               height:"1rem",
                borderRadius: "5px",
                fontWeight:"bold",
                textAlign:"center",
                textDecoration: "none",
                fontSize: "16px",
              }}
            >
              Download
            </a>
          </div>
        ))}
      </div>

      {/* Full Folder Download Button */}
      <div style={{ textAlign: "center", marginTop: "40px" }}>
        <button
          onClick={() =>
            downloadFolder(
              TABS[activeTab].folderId,
              TABS[activeTab].label
            )
          }
          disabled={folderLoading}
          className=".blueButton"
          style={{
            padding: "10px 20px",
 background:"linear-gradient(90deg, #4b77b1,#005498)",
               color:"white",            border: "none",
            borderRadius: "6px",
            fontFamily:"var(---default-font)",
            cursor: "pointer",
          }}
        >
          {folderLoading ? "Preparing ZIP..." : "Download Full Folder"}
        </button>
      </div>
    </div>
  );
}